export const formatCurrency = (value: number | undefined) => {
  if (typeof value !== 'number' || isNaN(value)) return ''
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value)
}
export const parseNumeric = (v: unknown): number | null => {
  if (v == null) return null
  if (typeof v === 'number' && !Number.isNaN(v)) return v
  if (typeof v === 'string') {
    const n = parseFloat(v.replace(/,/g, ''))
    return Number.isNaN(n) ? null : n
  }
  return null
}
export const toNumber = (v: any): number => {
  if (v == null) return 0
  const n = typeof v === 'string' ? parseFloat(v) : Number(v)
  return Number.isFinite(n) ? n : 0
}
export const formatNumPercentage = (num: number) => `${Math.round(num)}%`
export const formatDecimalPercentage = (decimal: number) => `${Math.round(decimal * 100)}%`
